import React from 'react';

import { Col, Row } from 'reactstrap';

import ResourceProperty from '../../../../common/resource/ResourceProperty';

import InternalResource from '../../../../common/resource/InternalResource';

import IsActive from '../../../../common/cells/IsActive';

import { numberFormatter } from '../../../../../utils/number';

import ManualVoucherPaymentPropTypes from '../propTypes/ManualVoucherPaymentInformationPropTypes';

import { MANUAL_VOUCHER_PATH } from '../../../../../config/paths';
import { tzNormalizeDate } from '../../../../../utils/date';
import { DATE_TIME_FORMAT } from '../../../../../config/locale';

const ManualVoucherPaymentResource = ({
  id,
  bankAccount,
  manualVoucherId,
  operationNumber,
  business,
  customer,
  amount,
  depositDate,
  approved,
  createDate,
  lastUpdate,
}) => {
  const paymentInformationResource = (
    <>
      <h3>Información del Pago</h3>

      <ResourceProperty label="Número de Operación:">
        {operationNumber || '-'}
      </ResourceProperty>

      <ResourceProperty label="Monto:">
        {numberFormatter({
          currency: bankAccount ? bankAccount.currency : undefined,
          value: amount,
        })}
      </ResourceProperty>

      <ResourceProperty label="Fecha de Depósito:">
        {depositDate
          ? tzNormalizeDate({ date: depositDate, format: DATE_TIME_FORMAT })
          : '-'}
      </ResourceProperty>

      <ResourceProperty label="Aprobado:">
        <input type="checkbox" checked={approved} readOnly />
      </ResourceProperty>

      <ResourceProperty label="Comprobante Relacionado:">
        {manualVoucherId ? (
          <a
            href={`${MANUAL_VOUCHER_PATH}/${manualVoucherId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {manualVoucherId}
          </a>
        ) : (
          '-'
        )}
      </ResourceProperty>
    </>
  );

  const bankAccountResource = bankAccount && (
    <>
      <h3>Cuenta Bancaria</h3>

      <ResourceProperty label="Número de Cuenta:">
        {bankAccount.accountNumber}
      </ResourceProperty>

      <ResourceProperty label="CCI:">
        {bankAccount.interbankNumber}
      </ResourceProperty>

      <ResourceProperty label="Moneda:">
        {bankAccount.currency}
      </ResourceProperty>

      <ResourceProperty label="Cuenta / Recibo:">
        {bankAccount.receipt || '-'}
      </ResourceProperty>

      <ResourceProperty label="Banco:">
        {bankAccount.bank ? bankAccount.bank.name : '-'}
      </ResourceProperty>

      <ResourceProperty label="Código SWIFT:">
        {bankAccount.bank ? bankAccount.bank.swiftCode || '-' : '-'}
      </ResourceProperty>

      <ResourceProperty label="País:">
        {bankAccount.bank && bankAccount.bank.country
          ? bankAccount.bank.country.name
          : '-'}
      </ResourceProperty>

      <ResourceProperty label="Código SUNAT:">
        {bankAccount.sunatTableCode || '-'}
      </ResourceProperty>

      <ResourceProperty label="Estado de Cuenta:">
        <IsActive value={bankAccount.active} />
      </ResourceProperty>
    </>
  );

  const accountBusinessResource =
    bankAccount && bankAccount.business ? (
      <>
        <h3>Empresa Titular de la Cuenta</h3>

        <ResourceProperty label="Razón Social:">
          {bankAccount.business.name}
        </ResourceProperty>

        <ResourceProperty label="RUC:">
          {bankAccount.business.businessTaxId}
        </ResourceProperty>

        <ResourceProperty label="Teléfono:">
          {bankAccount.business.phone || '-'}
        </ResourceProperty>

        <ResourceProperty label="Correo:">
          {bankAccount.business.email || '-'}
        </ResourceProperty>
      </>
    ) : null;

  const ownerResource = (
    <>
      <h3>Información del Titular</h3>

      {business && (
        <>
          <ResourceProperty label="Tipo:">Empresa</ResourceProperty>

          <ResourceProperty label="Razón Social:">
            {business.name}
          </ResourceProperty>

          <ResourceProperty label="RUC:">
            {business.businessTaxId}
          </ResourceProperty>

          <ResourceProperty label="Teléfono:">
            {business.phone || '-'}
          </ResourceProperty>

          <ResourceProperty label="Correo:">
            {business.email || '-'}
          </ResourceProperty>
        </>
      )}

      {customer && (
        <>
          <ResourceProperty label="Tipo:">Persona Natural</ResourceProperty>

          <ResourceProperty label="Nombre Completo:">
            {customer.fullName}
          </ResourceProperty>

          <ResourceProperty label="Tipo de Documento:">
            {customer.identificationType
              ? customer.identificationType.name
              : '-'}
          </ResourceProperty>

          <ResourceProperty label="N° de Documento:">
            {customer.idDocumentNumber || '-'}
          </ResourceProperty>
        </>
      )}

      {!business && !customer && (
        <ResourceProperty label="Titular:">-</ResourceProperty>
      )}
    </>
  );

  const internalResource = (
    <InternalResource id={id} createDate={createDate} lastUpdate={lastUpdate} />
  );

  return (
    <>
      <Row>
        <Col md={6}>{paymentInformationResource}</Col>

        <Col md={6}>{internalResource}</Col>
      </Row>

      <Row>
        <Col md={6}>{ownerResource}</Col>

        <Col md={6}>{bankAccountResource}</Col>
      </Row>

      {accountBusinessResource && (
        <Row>
          <Col md={6}>{accountBusinessResource}</Col>
        </Row>
      )}
    </>
  );
};

ManualVoucherPaymentResource.propTypes = ManualVoucherPaymentPropTypes;

export default ManualVoucherPaymentResource;
